<template>
  <div
    :class="[
      'cube-card',
      cardStatusClass_,
      cardCollaspe_,
      handleType_,
      handleRadius_,
      ...handleBorder_,
    ]"
  >
    <div
      v-if="hasHeader"
      :class="[
        'cube-card-header',
        handleActive_,
        handleBorderBottom_,
        handleRadius_,
      ]"
    >
      <div class="cube-card-header__title">
        <div class="title">
          <span class="collapse-icon" @click="hanleHeaderClick">
            <cnd-icon v-if="handleCollaspe_" name="cnd-arrow-right-on" />
            <template v-if="$slots['header-left']">
              <slot name="header-left">
                {{ title }}
              </slot>
            </template>
            <template v-else-if="$slots['title']">
              <slot name="title">
                {{ title }}
              </slot>
            </template>
            <template v-else>
              <span> {{ title }}</span>
            </template>
          </span>
        </div>
        <div class="ml-8 title-right">
          <template v-if="$slots['title-right']">
            <slot name="title-right" />
          </template>
          <template v-if="$slots['form-card-tag']">
            <slot name="form-card-tag" />
          </template>
        </div>
        <cnd-icon
          v-if="fullscreen"
          class="ml-8 pointer fs"
          :name="fullscreenEffect ? 'cnd-fullScreen-close' : 'cnd-fullScreen'"
          @click="setDialogPosition(fullscreenEffect ? 'close' : 'effect')"
        />
      </div>
      <div v-show="handleHideButton_" class="slot-buttons">
        <template v-if="$slots['header-right']">
          <slot name="header-right" />
        </template>
        <template v-if="$slots['form-card-btn']">
          <slot name="form-card-btn" />
        </template>
        <el-button v-if="enableMoreBtn" plain type="primary" @click="showMore">
          <cnd-icon :name="showMoreBtn ? 'cnd-arrow-up' : 'cnd-arrow-down'" />
        </el-button>
      </div>
    </div>
    <div class="pop-btn">
      <card-transition>
        <div v-show="showMoreBtn" class="more-buttons">
          <slot name="more-buttons" />
        </div>
      </card-transition>
    </div>
    <template v-if="$slots.default">
      <card-transition>
        <div
          v-show="isActive"
          class="cube-card-wrap"
          role="tabpanel"
          :aria-hidden="!isActive"
        >
          <div class="cube-card-wrap__content" :class="[...handlebodyPadding_]">
            <slot />
          </div>
        </div>
      </card-transition>
    </template>
  </div>
</template>
<script>
import CardTransition from './transition'
import '../../../../lib/styles/components/Card.scss'
export default {
  name: 'Card',
  components: {
    CardTransition
  },
  inject: {
    cardlist: { from: 'cardlist', default: '' }
  },
  props: {
    hasHeader: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    collapse: {
      type: Boolean,
      default: true
    },
    name: {
      type: String, // 唯一标识符，
      default: ''
    },
    fullscreen: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'default' // `default`, `nested`, `secondary`
    },
    status: {
      type: String,
      default: 'normal' // `normal`, `disabled`, `readOnly`
    },
    bodyPadding: {
      type: String,
      default: '' // `top`,`right`, `bottom`, `left`
    },
    border: {
      type: String,
      default: '' // `top`,`right`, `bottom`, `left`
    },
    radius: {
      type: Boolean,
      default: false
    },
    headerBorderBottom: {
      type: Boolean,
      default: false // 标题底部边框
    },
    hideButtons: {
      type: Boolean,
      default: true // 折叠状态下是否隐藏右侧按钮
    }
  },
  data() {
    return {
      fullscreenEffect: false,
      fullPath: '', // 记录当前页面路径
      preFullscreenEffect: false, // 离开前的状态
      selfActive: true,
      showMoreBtn: false,
      enableMoreBtn: false
    }
  },
  computed: {
    isActive() {
      const c = this.cardlist
      const name = this.cardlist ? this.cardlist.activeNames : []
      return !this.handleCollaspe_
        ? true
        : c
          ? name.indexOf(this.name) > -1
          : this.selfActive
    },
    handleCollaspe_() {
      if (!this.collapse && this.cardlist) {
        return false
      } else {
        return this.cardlist ? true : this.collapse
      }
    },
    handlebodyPadding_() {
      if (this.bodyPadding === '') {
        return []
      } else {
        const paddingSplit = this.bodyPadding.split(',')
        return paddingSplit.map((item) => {
          return `padding-${item}`
        })
      }
    },
    handleActive_() {
      return this.isActive ? 'isActive' : ''
    },
    handleBorderBottom_() {
      return this.$slots.default
        ? this.showMoreBtn
          ? false
          : this.isActive
            ? this.headerBorderBottom
              ? 'border-bottom'
              : ''
            : ''
        : ''
    },
    handleHideButton_() {
      // 非激活状态下 如果隐藏按钮 返回false 如果展示按钮返回true
      return !this.isActive ? !this.hideButtons : true
    },
    handleBorder_() {
      const key = 'border'
      const b = this.border
      if (b === 'border' || this.type === 'secondary') return [key] // || this.type === "secondary"
      if (b === '') {
        return []
      } else {
        const forEachFN = (item, i, arr) => {
          arr[i] = `${key}-${item}`
        }
        const split = b.split(',')
        split.forEach(forEachFN)
        return split
      }
    },
    handleType_() {
      const c = this.cardlist
      if (c) {
        return this.type === 'secondary' ? 'secondary' : 'nested'
      }
      return this.type
    },
    handleRadius_() {
      if (this.radius || this.handleType_ === 'default') {
        return 'radius'
      }
      return ''
    },
    cardStatusClass_() {
      return this.status === 'readOnly' || this.status === 'readonly'
        ? 'read-only'
        : this.status
    },
    cardCollaspe_() {
      return this.handleCollaspe_ ? 'collaspe' : ''
    },
    fullscreenClass_() {
      // this.selfActive = true
      return this.fullscreen
        ? this.fullscreenEffect === true
          ? 'card-screen-opened'
          : 'card-screen-closed'
        : ''
    }
  },
  watch: {
    cardlist: {
      handler(nv, ov) {
        if (nv) {
          if (!this.name) {
            console.warn('请传入name属性，提供一个唯一的标识符')
          }
        }
      },
      immediate: true
    },
    fullscreenClass_(nv, ov) {
      const dom = document.querySelector(this.fullscreen)
      if (!dom) {
        return console.warn('fullscreen dom is undefined')
      }
      dom.classList['add'](nv)
      dom.classList['remove'](ov)
    }
  },
  created() {
    if (this.$slots['more-buttons']) {
      this.$emit('showfn', this.showMore)
    }
  },
  async mounted() {
    if (this.$slots['more-buttons']) {
      this.enableMoreBtn = true
    }
    if (this.$slots['header-right'] || this.$slots['form-card-btn']) {
      await this.$nextTick()
      this.handleMoreButton()
    }
  },
  methods: {
    showMore() {
      this.showMoreBtn = !this.showMoreBtn
    },
    hanleHeaderClick() {
      const c = this.cardlist
      if (c) {
        c.handleItemClick(this)
      } else {
        this.selfActive = !this.selfActive
      }
    },
    async handleMoreButton() {
      if (!this.hasHeader) {
        return
      }

      const wrap = this.$el.querySelector('.cube-card-header')
      const title = this.$el.querySelector('.cube-card-header__title')
      const button = this.$el.querySelector('.slot-buttons')
      const domArr = Array.from(button?.children)
      const wrapWidth = wrap.clientWidth - 40 // 减去左右padding
      const buttonContentWidth = wrapWidth - title.clientWidth - 88 // 减去展开收起
      const domLen = domArr.length
      let buttonWidth = 0
      let findeIndex = null
      for (let i = 0; i < domLen; i++) {
        const width = domArr[i].clientWidth + 12
        if (buttonWidth + width > buttonContentWidth) {
          findeIndex = i
          break
        }
        buttonWidth += width
      }
      if (!findeIndex) return
      const more = this.$el.querySelector('.more-buttons')
      for (let i = findeIndex; i < domLen; i++) {
        more.appendChild(domArr[i])
      }
      this.enableMoreBtn = true
    },
    setDialogPosition(type = '') {
      const navbarEl = document.querySelectorAll('.navbar-banner')[0]
      const navbarLogo = document.querySelectorAll('.sidebar-logo')[0]
      if (type === 'effect') {
        this.fullscreenEffect = true

        // 用于判断当前是否处于全屏
        navbarEl && navbarEl.setAttribute('full-screen-opened', true)
        navbarLogo && navbarLogo.setAttribute('full-screen-opened', true)
      } else {
        this.fullscreenEffect = false
        if (type !== 'init') {
          navbarEl && navbarEl.removeAttribute('full-screen-opened')
          navbarLogo && navbarLogo.removeAttribute('full-screen-opened')
        }
      }
    }
  }
}
</script>
